import React from 'react';
import RenderItem from './RenderItem'
import { baseURL } from '../../api/baseURL';
import axios from 'axios';
import { connect } from 'react-redux';
import Loader from '../../Loader';
import Modal from '../../Modal';
import Pagination from '../Pagination';
import AdminShell from '../layout/AdminShell';
import { countPillStyle, thStyle } from '../layout/listUi';

type State = {
    requested: boolean,
    err: boolean,
    reportsList: any,
    photoOpen: boolean,
    modalOpen: boolean,
    currentPage: number,
};

class FeedbackPage extends React.Component<{ history: any, token: string }> {

    state: State = {
        requested: false,
        err: false,
        reportsList: null,
        photoOpen: false,
        modalOpen: false,
        currentPage: 1
    }

    componentDidMount(): void {
        if (!this.props.token) {
            window.location.pathname = "/";
        }
        else {
            this.getList(parseInt(window.location.search.split("?page=")[1]) ? parseInt(window.location.search.split("?page=")[1]) : 1);
        }
    }

    getList = (pageNumber: number) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.get(`${baseURL}/reports?page=${pageNumber}&limit=10`,
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        this.setState({ reportsList: response?.data, requested: false, err: false, currentPage: pageNumber })
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    toggleOpen = () => {
      //console.log("X");
        if (this.state.modalOpen) {
            this.setState({ modalOpen: false });
        }
        else if (!this.state.modalOpen) {
            this.setState({ modalOpen: true });
        }
    }

    toggleModal = () => {
        if (this.state.err) {
            this.setState({ err: false });
        }
    }

    onPageChange = (pageNumber: number) => {
        this.getList(pageNumber);
    }

    render() {
        return (
            <AdminShell activePage="feedback" title="Feedback & Reports" subtitle="Customer-submitted feedback and bug reports">
                <Modal open={this.state.err} hideSec primaryText="Okay" title='Update' onConfirm={this.toggleModal} toggleOpen={this.toggleModal} content={<h6>Something went wrong, please try again later</h6>} />
                {this.state.requested ? <Loader /> : null}
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">
                            Feedbacks / Reports
                            {this.state.reportsList?.total ? <span style={countPillStyle}>{this.state.reportsList.total}</span> : null}
                        </h4>
                        <div className="table-responsive">
                            {(this.state.reportsList?.reports?.length) ? <table className="table">
                                <thead>
                                    <tr>
                                        <th style={thStyle}>Customer Email</th>
                                        <th style={thStyle}>Title</th>
                                        <th style={thStyle}>Description</th>
                                        <th style={thStyle}>Is Feedback?</th>
                                        <th style={thStyle}>Report / Feedback Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.reportsList?.reports?.length ?
                                        this.state.reportsList?.reports.map((item: any) => {
                                            return <RenderItem item={item} />;
                                        })
                                        : null}
                                </tbody>
                            </table> : <div style={{ display: 'flex', justifyContent: 'center', padding: 15, paddingTop: 30 }}>
                                <div className="badge badge-outline-secondary" style={{ fontSize: 16 }}>No Data</div>
                            </div>}
                        </div>
                    </div>
                </div>
                {(this.state.reportsList?.total / 10) > 1 ? <Pagination onPageChange={this.onPageChange} currentPage={this.state.currentPage} totalPages={(this.state.reportsList?.total / 10) < 1 ? (this.state.reportsList?.total / 10) : Math.ceil(this.state.reportsList?.total / 10)} maxVisible={5} /> : null}
            </AdminShell>
        );
    }
}

const mapDispatchToProps = (dispatch: Function) => {
    return {
        dispatch
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        token: state.auth.token
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackPage);
